export default __webpack_public_path__ + "static/media/india.1434165a.svg";